// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const CONTACT_NOT_FOUND = 'Contact not found'
